import { LOADING_SETTING_SUCCESS, UPDATING_SETTING_SUCCESS } from './settings';
import {
    persistEditionId,
    readPersistedEditionId,
    readPersistedEditionIdForUserInstance,
} from '../../services/editionPrefs';

export { readPersistedEditionId, persistEditionId };

const SET_AVAILABLE_EDITIONS = 'kronos/editionNavigation/SET_AVAILABLE_EDITIONS';
const SET_SELECTED_EDITION_ID = 'kronos/editionNavigation/SET_SELECTED_EDITION_ID';

const AUTH_LOG_IN_SUCCESS = 'kronos/auth/LOG_IN_SUCCESS';
const AUTH_REGISTER_SUCCESS = 'kronos/auth/REGISTER_SUCCESS';
const AUTH_SPOOF_SUCCESS = 'kronos/auth/SPOOF_SUCCESS';
const AUTH_UPDATE_AUTH_USER = 'kronos/auth/UPDATE_AUTH_USER';
const AUTH_LOG_OUT = 'kronos/auth/LOG_OUT';

function edition_doc_id(edition) {
    return String(edition?._id || edition?.id || '');
}

function selected_edition_in_list(selectedEditionId, editions) {
    if (!selectedEditionId) {
        return true;
    }
    const want = String(selectedEditionId);
    return (editions || []).some((e) => edition_doc_id(e) === want);
}

const initialState = {
    /** Array of editions from API (Kore engine-backed model) */
    editions: [],
    /** Edition id used to scope the UI + API calls */
    selectedEditionId: readPersistedEditionId(),
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_AVAILABLE_EDITIONS: {
            // Definitive list only — callers must not dispatch [] while still
            // loading. Empty means "no editions for this instance" / cannot
            // list: drop selection so we never inject a foreign ?edition=
            // (e.g. after leaving NIFFF 2026 for an instance without editions).
            const editions = action.editions || [];
            if (state.selectedEditionId && !selected_edition_in_list(state.selectedEditionId, editions)) {
                persistEditionId(null);
                return { ...state, editions, selectedEditionId: null };
            }
            return { ...state, editions };
        }
        case SET_SELECTED_EDITION_ID:
            persistEditionId(action.editionId);
            return { ...state, selectedEditionId: action.editionId || null };
        case LOADING_SETTING_SUCCESS:
        case UPDATING_SETTING_SUCCESS: {
            if (state.selectedEditionId) {
                return state;
            }
            const configured = action.setting?.edition;
            if (!configured) {
                return state;
            }
            persistEditionId(configured);
            return { ...state, selectedEditionId: String(configured) };
        }
        case AUTH_LOG_IN_SUCCESS:
        case AUTH_REGISTER_SUCCESS:
        case AUTH_SPOOF_SUCCESS:
        case AUTH_UPDATE_AUTH_USER: {
            const u = action.user;
            const uid = u?.id != null ? String(u.id) : null;
            const iid = u?.tkt_instance?.id != null ? String(u.tkt_instance.id) : 'none';
            // Reset the list so the previous instance's editions cannot keep a
            // foreign selectedEditionId alive; selection comes from prefs for
            // this user+instance only, then App/EditionSelector refills the list.
            return {
                ...state,
                editions: [],
                selectedEditionId: readPersistedEditionIdForUserInstance(uid, iid),
            };
        }
        case AUTH_LOG_OUT:
            return { ...state, editions: [], selectedEditionId: null };
        default:
            return state;
    }
}

export function setAvailableEditions(editions) {
    return { type: SET_AVAILABLE_EDITIONS, editions };
}

export function setSelectedEditionId(editionId) {
    return { type: SET_SELECTED_EDITION_ID, editionId: editionId ? String(editionId) : null };
}
